<div class="text-break-space" nz-tooltip [nzTooltipTitle]="note" nzPlacement="bottom" #myDiv>
  {{briefNote || note}}
</div>